import { render, staticRenderFns } from "./delete-event.vue?vue&type=template&id=03242e9b&"
import script from "./delete-event.vue?vue&type=script&lang=ts&"
export * from "./delete-event.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports